
import Layout from "../../Shared/Layout";
import ListUser from "./CountComponent/AccountCount";

import CustomerForm from './AccountForm/CustomerForm';
import CreateUser from "./AccountForm/CreateUser";

const CustomerPage = () => {

  return (
    <Layout>
      {/* Affichage de la liste d'utilisateurs et d'autres composants */}
      <div className="content-body default-height">
        <div className="container-fluid">
            <CreateUser />
            <ListUser />
        </div>
      </div>

      <CustomerForm/>
    </Layout>
  );
};

export default CustomerPage;
